import React from "react";
import Modal from "react-bootstrap/Modal";

export default function Consent({ showConsent, handleClose, name }) {
  return (
    <>
      <Modal
        show={showConsent}
        onHide={handleClose}
        style={{ height: "90vh", margin: "20px" }}
      >
        <Modal.Header closeButton style={{ justifyContent: "center" }}>
          <Modal.Title style={{ color: "#efb331" }}>
            Consent Agreement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
          <div style={{ fontFamily: "garamond", lineHeight: 1.6 }}>
            <p>Hello {name},</p>
            <p>
              ProvidusBank Limited has received a request to open a new account
              in your name. To proceed, we need your explicit authorization.
              Please review the details below carefully before responding.
            </p>
            <p>By selecting Accept, you consent to:</p>
            <ul>
              <li>
                Opening a new bank account in your name with ProvidusBank
                Limited
              </li>
              <li>
                Completing Face ID verification for secure identity
                authentication
              </li>
            </ul>
            <p>
              Didn&apos;t request this? If you did not initiate this account
              opening, click Decline immediately and contact us at{" "}
              <a href="mailto:frauddesk@providusbank.com">
                frauddesk@providusbank.com
              </a>
            </p>
            <p>
              Your account will be on restriction and will be activated
              once you complete the statutory KYC requirements. Kindly visit any
              of our Branches closest to you or call our Business Concierge on{" "}
              <b className="text-danger underline">070077684387</b>,{" "}
              <b className="text-danger underline">02012270200</b> or email{" "}
              <b className="text-danger underline">
                businessconcierge@providusbank.com
              </b>{" "}
              to complete the account-opening documentation and activate your
              account.
            </p>
            {/* <p>
              ✓ Accept &amp; Proceed
              <br />X Decline Request
            </p> */}
            <p>
              Your personal information is collected solely to provide and
              tailor our banking services. We do not share your data with third
              parties except as required by law.
            </p>
            <p>
              Read our{" "}
              <a
                href="https://www.providusbank.com/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>{" "}
              for full details.
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
